import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/ai-response/{aiResponseId}/create-slide/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createSlide = (aiResponseId, params) => {
  return resource.createSlide({ aiResponseId }, params)
}

export default {
  initResource,
  createSlide,
}
